import { Search, X } from 'lucide-react';

function SearchInput({ placeholder = '검색어 입력', value, onChange, onSearch, onClear }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) onSearch();
  };

  return (
    <div className="flex items-center sm:justify-end justify-center mb-5">
      <div className="relative w-full sm:w-72">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" />
        <input
          type="text"
          placeholder={placeholder}
          className="w-full pl-8 pr-8 py-2 rounded-full border border-white/10 bg-white/5 text-white placeholder-slate-500 text-sm focus:outline-none focus:border-sky-500/50 transition-colors"
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
        {value && onClear && (
          <button onClick={onClear} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-white">
            <X size={13} />
          </button>
        )}
      </div>
    </div>
  );
}

export default SearchInput;
